export default function WhyUsSection() {
  const features = [
    {
      icon: 'ri-vip-crown-line',
      title: 'Premium kwaliteit gegarandeerd',
      description:
        'Wij werken uitsluitend met A-merken zoals Moduleo, BerryAlloc en Quick-Step. Elk product wordt zorgvuldig geselecteerd op duurzaamheid, krasvastheid en esthetiek. U krijgt standaard 15 jaar garantie op ons vakmanschap.',
    },
    {
      icon: 'ri-hammer-line',
      title: 'Vakmanschap van ervaren specialisten',
      description:
        'Onze leggers hebben gemiddeld 12+ jaar ervaring en zijn gecertificeerd. Van nauwkeurige opmeting tot millimeterprecieze afwerking — elk detail krijgt de aandacht die het verdient.',
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Transparante prijzen zonder verrassingen',
      description:
        'Wat u ziet is wat u betaalt. Onze offertes zijn all-in: materialen, leggen, ondervloer en afvoer oude vloer. Geen verborgen kosten of meerwerk achteraf. U weet vooraf exact waar u aan toe bent.',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Persoonlijke service van A tot Z',
      description:
        'Van het eerste adviesgesprek tot jaren na oplevering — wij staan voor u klaar. Onze adviseurs nemen uitgebreid de tijd om uw wensen, budget en situatie te bespreken.',
    },
  ];

  return (
    <section className="py-20 sm:py-24 bg-cream-50 overflow-hidden rounded-t-[2rem] sm:rounded-t-[3rem] rounded-b-[2rem] sm:rounded-b-[3rem]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-16">
          <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-brass-500/10 rounded-full border border-brass-500/20 mb-4 sm:mb-6">
            <i className="ri-award-fill text-brass-500 text-sm"></i>
            <span className="text-xs sm:text-sm font-medium text-brass-600">Waarom Kiezen Voor Ons</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light text-ink-900 mb-3 sm:mb-4">
            Uw PVC vloer specialist met{' '}
            <span className="font-medium text-brass-600">kwaliteit en service</span>
          </h2>
          <p className="text-sm sm:text-base text-ink-600 max-w-2xl mx-auto">
            Al meer dan 12 jaar uw specialist in hoogwaardige PVC vloeren. Ontdek wat ons onderscheidt.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center mb-12 sm:mb-16">
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                alt="Vakmanschap PVC vloer installatie"
                className="w-full h-[300px] sm:h-[400px] lg:h-[500px] object-cover"
                src="https://readdy.ai/api/search-image?query=Professional%20craftsman%20renovation%20worker%20installing%20tiles%20modern%20bathroom%20precise%20work%20skilled%20tradesman%20residential%20project%20warm%20lighting%20high%20quality%20photography%20clean%20interior"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
            </div>

            {/* Floating card */}
            <div className="absolute -bottom-4 sm:-bottom-6 -right-2 sm:-right-6 bg-white rounded-2xl shadow-2xl p-4 sm:p-8 border border-gray-100">
              <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4">
                <div className="w-12 h-12 sm:w-16 sm:h-16 bg-brass-100 rounded-xl flex items-center justify-center">
                  <i className="ri-team-line text-brass-600 text-xl sm:text-3xl"></i>
                </div>
                <div>
                  <div className="text-xl sm:text-3xl font-bold text-ink-900">2.400+</div>
                  <div className="text-xs sm:text-sm text-ink-600">Gelegde vloeren</div>
                </div>
              </div>
              <div className="flex items-center gap-2 text-brass-600">
                <div className="flex">
                  <i className="ri-star-fill text-sm sm:text-base"></i>
                  <i className="ri-star-fill text-sm sm:text-base"></i>
                  <i className="ri-star-fill text-sm sm:text-base"></i>
                  <i className="ri-star-fill text-sm sm:text-base"></i>
                  <i className="ri-star-fill text-sm sm:text-base"></i>
                </div>
                <span className="font-semibold text-sm">4.9/5</span>
              </div>
            </div>
          </div>

          <div className="space-y-6 sm:space-y-8 mt-8 lg:mt-0">
            {features.map((feature, i) => (
              <div key={i}>
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-brass-100 rounded-xl flex items-center justify-center shrink-0">
                    <i className={`${feature.icon} text-brass-600 text-lg sm:text-2xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-lg sm:text-2xl font-bold text-ink-900 mb-2 sm:mb-3">{feature.title}</h3>
                    <p className="text-sm sm:text-base text-ink-600 leading-relaxed">{feature.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center">
          <a
            href="#offerte"
            className="inline-flex items-center gap-2 bg-brass-600 hover:bg-brass-700 text-white px-6 sm:px-8 py-3.5 sm:py-4 rounded-xl font-semibold text-base sm:text-lg transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-calculator-line text-lg sm:text-xl"></i>
            Vraag Gratis Offerte Aan
          </a>
        </div>
      </div>
    </section>
  );
}